import type { IModularBenefitMessages } from '@ben/shared/types/columbia';
import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import LifeEventsSection from '../life-events/life-events-section';
import { SectionContainer } from './styles';
import type { LifeEventsForm, StepsForm } from './types';

interface LifeEventsElementProps {
  form: LifeEventsForm;
  stepsForm: StepsForm;
  errors: IModularBenefitMessages;
  successes: IModularBenefitMessages;
}

const LifeEventsElement = ({
  form,
  stepsForm,
  errors,
  successes,
}: LifeEventsElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <LifeEventsSection
        stepsForm={stepsForm}
        errors={errors}
        successes={successes}
      />
    </FormProvider>
  </SectionContainer>
);

export default memo(LifeEventsElement);
